import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { PhonePipe } from './phone.pipe';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { InputFocus } from './input-focus.directive';
import { RaffleFooterComponent } from './component/raffle-footer/raffle-footer.component';
import { SelectableSearchPage } from './component/selectable-search/selectable-search';
import { QRCodeModule } from 'angularx-qrcode';
import { CoreModule } from '../core/core.module';
import { PrizeDetailCardComponent } from './component/prize-detail-card/prize-detail-card.component';


@NgModule({
  declarations: [
    PhonePipe,
    InputFocus,
    RaffleFooterComponent,
    SelectableSearchPage,
    PrizeDetailCardComponent
  ],
  imports: [
    CoreModule,
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    QRCodeModule
  ],
  exports: [
    PhonePipe,
    InputFocus,
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    RaffleFooterComponent,
    SelectableSearchPage,
    PrizeDetailCardComponent,
    QRCodeModule,
    CoreModule
  ],
  providers: [
    InAppBrowser
  ]
})
export class SharedModule { }
